import React, { useState } from 'react'
import FormField from '../../atoms/FormField/FormField'
import FormInput from '../../atoms/FormInput/FormInput'
import Button from '../../atoms/Button/Button'
import { Formik } from 'formik'
import Link from 'next/link'
import * as yup from 'yup'
import useTrans from '../../../hooks/useTrans'

const validationSchema = yup.object({
  username: yup.string().required('il campo username è richiesto'),
  password: yup.string().required('Il campo password è richiesto'),
})

const LoginTemplate = ({
  noTitle,
  Login,
  CredentialError,
  ClosePopup,
  service_gift,
  login_text,
}) => {
  const [error, setError] = useState(null)
  const service_gift_text = service_gift?.attivo ? 'service_gift-' : ''
  const t = useTrans()
  function createMArkup(testo) {
    return { __html: testo }
  }
  return (
    <div className="login">
      <div className="login__content">
        <p className="login__title">{t(`${service_gift_text}Accedi`)}</p>
        <p className="login__description">
          {t(`${service_gift_text}Accedi per visualizzare i prezzi per te, per controllare gli ordini e
          molto altro`)}
        </p>
        <Formik
          validationSchema={validationSchema}
          initialValues={{
            password: '',
            username: '',
          }}
          onSubmit={({ username, password }) => {
            const params = {
              email: username,
              password: password,
            }
            Login(params)
              .then(() => setError(null))
              .catch((err) => setError(err.message))
          }}
        >
          {(props) => (
            <>
              <FormField
                label="Username"
                status={
                  props.touched.username && props.errors.username
                    ? 'error'
                    : props.touched.username && 'success'
                }
                errorMessage={props.errors.username}
              >
                <FormInput
                  value={props.values.username}
                  onChange={props.handleChange('username')}
                  onBlur={props.handleBlur('username')}
                />
              </FormField>

              <FormField
                label="Password"
                status={
                  props.touched.password && props.errors.password
                    ? 'error'
                    : props.touched.password && 'success'
                }
                errorMessage={props.errors.password}
              >
                <FormInput
                  type="password"
                  value={props.values.password}
                  onChange={props.handleChange('password')}
                  onBlur={props.handleBlur('password')}
                />
              </FormField>
              {error && <p style={{ color: 'red' }}>{error}</p>}
              {CredentialError && <p style={{ color: 'red' }}>{t('Credenziali Errate')}</p>}

              {!service_gift && CredentialError && (
                <p style={{ color: 'red' }}>
                  {t(
                    'Se accedevi al vecchio sito, utilizza le stesse credenziali con la username e la password scritte in minuscolo'
                  )}
                </p>
              )}

              <Link href="/myaccount/recupera-password">
                <a className="login__password-recovery">{t('Recupera la password')}</a>
              </Link>

              <Button
                label="Accedi"
                variant="primary"
                size="medium"
                onClick={() => props.handleSubmit()}
                disabled={!props.isValid || !props.dirty}
              />
            </>
          )}
        </Formik>
      </div>
      <div className="login__content">
        <p className="login__title">{t(`${service_gift_text}Registrati`)}</p>
        <div
          className="login__description"
          dangerouslySetInnerHTML={createMArkup(login_text?.login_text?.descrizione)}
        >
          {/* <p>{t(`${service_gift_text}Registrati per usufruire di tutti i vantaggi di Sipec`)}</p> */}
          {/* <ul className="u-content-list">
            <li>{t(`${service_gift_text}Prezzi sempre aggiornati`)}</li>
            <li>{t(`${service_gift_text}Sempre la disponibilità reale degli articoli`)}</li>
            <li>
              {t(
                `${service_gift_text}Potri inserire direttamente i tuoi ordini on-line (uno shop 24/24)`
              )}
            </li>
            <li>
              {t(`${service_gift_text}Potrai approfittare delle offere e consultare gli articoli fine
              serie e fuori catalogo`)}
            </li>
          </ul> */}
        </div>
        <Link href="/myaccount/registrazione" onClick={() => ClosePopup()}>
          <a className="login__button">
            <Button label={t(`${service_gift_text}Registrati`)} variant="secondary" size="medium" />
          </a>
        </Link>
      </div>
    </div>
  )
}

export default LoginTemplate
